import React from "react";
import {
  Link,
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as coupleAction from '../action/coupleAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
//Dialog
import DialogCoupleReceptionOk from './DialogCoupleReceptionOk';
import DialogConfirm from './DialogConfirm';
//Icon


class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogCoupleReceptionOk: false,
      dialogCoupleReceptionNg: false,
    }
  }

  _coupleReceptionNg(couple_id) {
    this.props.coupleReceptionNg(couple_id);
  }

	render() {
    let value = this.props.value;
    return (
      <div style={{margin:'2% 0%'}}>
        <Box boxShadow={2} style={{background:'#FFF'}} className='round12'>
          <div style={{padding:'10px'}}>
            <h2 align='center'>カップリングが申し込まれました</h2>
            <div align='center'>{value.couple_datetime}</div>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'center', alignItems:'center'}}>
              <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                <PartUserMainImg
                  mainImg={value.userdata_mainImg}
                  width={'50px'}
                  height={'50px'}
                  radius={'50%'}
                />
              </Link>
              &nbsp;
              <Link to={{ pathname: '/partner/' + value.userdata_id_code}}>
                <PartUserName
                  data={{
                    name: value.userdata_name,
                    sex: value.userdata_sex,
                    size: '1.2em',
                  }}
                />
              </Link>
            </div>
            <div>
              <div style={{margin:'10px'}}>
                カップリングとはライバルが現れない環境でお二人の関係を築いていただく機能です
              </div>

              <ul>
                <li style={{marginLeft:'2em'}}>
                  2人とも検索結果にプロフィールが表示されなくなります
                </li>
                <li style={{marginLeft:'2em'}}>
                  2人ともプロフィールにカップリング中と表示されます
                </li>
              </ul>

              <div align='center' style={{margin:'15px'}}>
                <Button
                  color="primary"
                  variant={ "outlined" }
                  onClick={ () => this.props.helpOpen('category','couple') }
                >
                  「カップリング」について
                </Button>
              </div>

              <div align='center'>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={ () => this.setState({dialogCoupleReceptionOk: true}) }
                >
                  よろしく
                </Button>
                &nbsp;
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ () => this.setState({dialogCoupleReceptionNg: true}) }
                >
                  ごめんなさい
                </Button>
              </div>

              <DialogCoupleReceptionOk
                coupleId={ value.couple_id }
                pic={ value.userdata_id_code }
                open={ this.state.dialogCoupleReceptionOk }
                close={ () => this.setState({dialogCoupleReceptionOk: false}) }
              />

              <DialogConfirm
                open={ this.state.dialogCoupleReceptionNg }
                title={'カップリング'}
                content={'カップリングをお断りしてもいいですか？'}
                apply={ () => {
                  this._coupleReceptionNg(value.couple_id);
                  this.setState({dialogCoupleReceptionNg: false});
                } }
                close={ () => this.setState({dialogCoupleReceptionNg: false}) }
              />
            </div>
          </div>
        </Box>
      </div>
    )
	}
}

const mapStateToProps = (state) => {
	return {
    notification: state.notification,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...coupleAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
